"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : LOADER : STYLES--------------- ++++++++++ */


var _default = {
  loader: {
    display: 'inline-block',
    position: 'relative',
    width: (0, _index.pxToEm)(64),
    height: (0, _index.pxToEm)(64),
    '& div': {
      boxSizing: 'border-box',
      display: 'block',
      position: 'absolute',
      width: (0, _index.pxToEm)(51),
      height: (0, _index.pxToEm)(51),
      margin: (0, _index.pxToEm)(6),
      border: (0, _index.replacePXinStringWithEM)("6px solid #fff"),
      borderRadius: '50%',
      animation: 'lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
      borderColor: "".concat(_index.theme.color.primary.medium.swatch, " transparent transparent transparent"),
      '&:nth-child(1)': {
        animationDelay: '-0.45s'
      },
      '&:nth-child(2)': {
        animationDelay: '-0.3s'
      },
      '&:nth-child(3)': {
        animationDelay: '-0.15s'
      }
    },
    // ----- colors ----- //
    // generates classes for every color in the theme ".color-(uniqueColor)"
    extend: (0, _index.themeStyleHelper)(_index.theme, 'color', function (theme, uniqueColor) {
      return {
        '& div': {
          borderTopColor: theme.color[uniqueColor].medium.swatch
        }
      };
    })
  },
  '@global': {
    '@keyframes lds-ring': {
      '0%': {
        transform: 'rotate(0deg)'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    }
  }
};
exports.default = _default;